export default "__VITE_ASSET__BrYXQQ1y__"